import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/news-info/news-info.tsx");
